export * from "-!../../../../node_modules/cache-loader/dist/cjs.js!../../../../node_modules/babel-loader/lib/index.js??ref--2-1!../../../../node_modules/vue-loader/lib/loaders/templateLoader.js??ref--2!../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./VideoImage.vue?vue&type=template&id=bdc33fa8&scoped=true"


//////////////////
// WEBPACK FOOTER
// ./scripts/vue/VideoImage.vue?vue&type=template&id=bdc33fa8&scoped=true
// module id = 141
// module chunks = 0